import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DirtyFormService } from "~app/common/services/dirty-form.service";
import { DirtyTabComponent } from "~app/features/regelverk-viol/dirtyTabComponent";
import { ResponsePanelComponent } from "../../components/response-panel/response-panel.component";
import { SystemadministrationService } from "../../systemadministration.service";
import { Avverkningsanmalan } from "./avverkningsanmalan.model";

@Component({
    selector: "rask-sysadm-avverkningsanmalan",
    templateUrl: "./sysadm-avverkningsanmalan.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        InputComponent,
        FormsModule,
        ButtonComponent,
        ResponsePanelComponent
    ]
})
export class SysadmAvverkningsanmalanComponent extends DirtyTabComponent {
    atgardsBeteckning: string;
    operationResult = new Avverkningsanmalan();
    searchedForAtgard = false;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);

    constructor() {
        const dirtyFormService = inject(DirtyFormService);

        super(dirtyFormService);
    }

    canSave(): boolean {
        return true;
    }

    isDirtyCheck(): boolean {
        return false;
    }

    newSearch(): void {
        this.operationResult = new Avverkningsanmalan();
        this.operationResult.message = "Hämta en ny åtgärd...";
    }

    restoreChanges(): void {
        // ska vara tom
    }

    saveChanges(): void {
        // ska vara tom
    }

    updateAvverkningsanmalan(): void {
        this.newSearch();
        this.busyService.addWork(this.administrationService.updateAvverkningsanmalan(this.atgardsBeteckning))
            .subscribe(result => {
                this.operationResult = result;
                this.searchedForAtgard = true;
            });
    }
}
